import React from "react";
import Dashboard from "../../components/Dashboard/Dashboard";

const Home = ({ closed }) => {
  return <Dashboard closed={closed} />;
};

export default Home;
